import { useEffect } from "react";

/**
 * Hook clavier — enregistre des raccourcis clavier globaux.
 * shortcuts = { "R": () => ..., "ArrowDown": () => ..., "cmd+k": () => ... }
 */
export function useHotkeys(shortcuts, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e) => {
      // Ne pas intercepter dans les inputs / textareas / contenteditable
      const t = e.target;
      const tag = (t?.tagName || "").toLowerCase();
      const isTextField = tag === "input" || tag === "textarea" || t?.isContentEditable;

      const mod = e.metaKey || e.ctrlKey;
      const key = e.key;
      const combo = `${mod ? "mod+" : ""}${key.length === 1 ? key.toLowerCase() : key}`;

      // Cmd+K passe partout même dans les inputs
      if (combo === "mod+k" && shortcuts[combo]) {
        e.preventDefault();
        shortcuts[combo](e);
        return;
      }
      if (isTextField) return;

      const fn = shortcuts[combo] || shortcuts[key] || shortcuts[key.toLowerCase()];
      if (fn) {
        e.preventDefault();
        fn(e);
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [shortcuts, enabled]);
}
